import React, { useState, useEffect, Suspense, useRef } from 'react';
import { Outlet, useParams, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { LayoutContext } from '../Context/LayoutContext';
import PageLoader from '../components/PageLoader';

const UserLayout = () => {
  const { eventId } = useParams();
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    if (prevPathRef.current !== location.pathname) {
      setTransitioning(true);
      const t = setTimeout(() => setTransitioning(false), 20);
      prevPathRef.current = location.pathname;
      return () => clearTimeout(t);
    }
  }, [location.pathname]);

  return (
    <>
      <Navbar className="sticky-navbar" eventId={eventId} />
      <LayoutContext.Provider value={true}>
        <div
          key={location.pathname}
          className={`page-content-wrapper${transitioning ? ' page-entering' : ''}`}
        >
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </div>
      </LayoutContext.Provider>
    </>
  );
};

export default UserLayout;
